<template>
  <div class="plan-item">
    <div class="row">
      <div class="col-12">
        <div class="tariff box" :class="{'is-disabled disabled-block': isDisabled}">
          <div class="tariff__icon svg-icon color-white bg-green_light" aria-hidden="true">
            <svg role="img" width="30" height="30" aria-hidden="true">
              <use xlink:href="#svg-icon-home"></use>
            </svg>
          </div>
          <div class="tariff__content box bg-white">
            <div class="row align-items-center">
              <div class="col-12 col-lg-12 col-xl-12">
                <div class="tariff__id color-gray">{{ $t("contract") }} № {{ contract.numberContract || '0000' }}</div>
                <div class="row mt_25" style="justify-content: space-between">
                  <div class="col-12 col-md-auto">
                    <div class="tariff__title section__title section__title_style3"><span class="block_name">{{ $t("balance") }}:</span><span :class="isDisabled ? '' : contract.obk >= 0 ? 'color-green' : 'color-red'">{{ contract.obk ? formatOBK(contract.obk) : '0' }} {{$t("tenge")}}</span></div>
                    <div class="section__title_style3 secondary_block">
                      <span class="block_name">{{ $t("placeOfPayment") }}:</span> 
                      <span v-if="contract.payment === 'POST'" :class="{'color-green': !isDisabled}">{{ $t("paymentType") }}</span>
                      <span class="tariff-name" v-else :class="{'color-green': !isDisabled}">{{ $t("paymentType2") }} <img src="/images/svg/error_circle.svg" :title="$t('paymentWarning')"></span>
                    </div>
                  </div>
                  <div class="col-12 col-md-auto mt_10">
                    <div class="tariff__title section__title section__title_style3"><span class="block_name">{{ $t("debtAmount") }}:</span><span :class="isDisabled ? '' : contract.debtAmount >= 0 ? 'color-green' : 'color-red'">{{ contract.debtAmount ? formatOBK(contract.debtAmount) : '0' }} {{$t("tenge")}}</span></div>
                  </div>
                  <div class="col-6 col-md-auto">
                    <button @click="$router.push('/finances')" :disabled="isDisabled" class="btn btn_white btn_finance btn_more btn_with-icon" :class="{'disabled-btn': isDisabled}" type="button"><span
                      class="btn__text">{{$t("more")}}</span><span class="btn__icon svg-icon" aria-hidden="true">
                        <svg role="img" width="20" height="20" aria-hidden="true">
                          <use xlink:href="#svg-icon-arrow-next"></use>
                        </svg></span>
                    </button>
                    <button v-if="false" class="link tariff__control" type="button" data-target="#modal-payment"
                            data-toggle="modal" :aria-label='$t("editPaymentType")'><span
                        class="link__icon svg-icon">
                            <svg role="img" width="24" height="24" aria-hidden="true">
                              <use xlink:href="#svg-icon-edit"></use>
                            </svg></span><span
                        class="link__text">{{ contract.payment === 'POST' ? $t("paymentType") : $t("paymentType2") }}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6 col-xl-5">
                <div v-if="false" class="btn-group btn-group_double">
                  <router-link class="btn btn_default btn_green btn_with-icon" to="/change-tariff"><span
                      class="btn__icon svg-icon" aria-hidden="true">
                          <svg role="img" width="24" height="24" aria-hidden="true">
                            <use xlink:href="#svg-icon-edit"></use>
                          </svg></span><span class="btn__text">{{ $t("change") }}</span></router-link>
                  <router-link class="btn btn_default btn_white btn_with-icon" to="/reservation-select"><span
                      class="btn__icon svg-icon" aria-hidden="true">
                          <svg role="img" width="24" height="24" aria-hidden="true">
                            <use xlink:href="#svg-icon-pause"></use>
                          </svg></span><span class="btn__text">{{ $t("booking") }}</span></router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product-block" v-for="product in contract.ProductObject" :key="product.idProduct">
        <div class="col-12 col-lg-6">
          <div class="row">
            <div class="col-12">
              <div class="about-assistant box bg-white">
                <div class="about-assistant__icon box__icon svg-icon color-white bg-green_light"
                    aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-wallet"></use>
                  </svg>
                </div>
                <div class="about-assistant__content">
                  <div class="about-assistant__title section__title section__title_style3">{{$t("tariffPlan")}}</div>
                  <div class="tariff__title section__title section__title_style3 color-green" style="padding-right: 43px;">
                    {{ product.tariff || $t("unknown") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="info-block box bg-white disabled-block">
                <div class="info-block__icon box__icon svg-icon color-white bg-green_light is-disabled" aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-assistant"></use>
                  </svg>
                </div>
                <div class="info-block__content">
                  <div class="info-block__title section__title section__title_style3">{{$t("assistant")}}</div>
                  <div class="info-block__descr section__description color-gray">
                    <p>{{$t("assistantText")}}</p>
                  </div>
                  <div class="btn-group btn-group_double">
                    <button class="btn btn_default is-disabled" type="button">
                            <span class="btn__text">
                              <span class="btn__icon svg-icon" aria-hidden="true">
                                <svg role="img" width="24" height="24" aria-hidden="true">
                                  <use xlink:href="#svg-icon-phone2"></use>
                                </svg>
                              </span>
                            </span>
                    </button>
                    <button class="btn btn_default is-disabled" type="button">
                            <span class="btn__text">
                              <span class="btn__icon svg-icon" aria-hidden="true">
                                <svg role="img" width="24" height="24" aria-hidden="true">
                                  <use xlink:href="#svg-icon-chat"></use>
                                </svg>
                              </span>
                            </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="info-block box bg-white">
                <div class="info-block__icon box__icon svg-icon color-white bg-green_light" aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-mail"></use>
                  </svg>
                </div>
                <div class="info-block__content">
                  <div class="info-block__title section__title section__title_style3">{{$t("messages")}}</div>
                  <div class="info-block__descr section__description color-gray">
                    <p v-if="newMessage">{{ newMessage.message_object.title }}</p>
                    <p v-else>{{$t("notNewMessage")}}</p>
                  </div>
                  <button :disabled="!newMessage" :class="{'disabled-btn': !newMessage}"
                          @click="$router.push(`/message/${newMessage.id}`)"
                          class="btn btn_white btn_more btn_with-icon" type="button"><span class="btn__text">{{$t("more")}}</span><span
                      class="btn__icon svg-icon" aria-hidden="true">
                          <svg role="img" width="20" height="20" aria-hidden="true">
                            <use xlink:href="#svg-icon-arrow-next"></use>
                          </svg></span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="row">
            <div class="col-12 col-sm-6" v-if="getService(product.ServiceObject, 'Интернет')">
              <div class="service-block box">
                <div class="service-block__icon box__icon svg-icon color-white bg-green_light" aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-wifi"></use>
                  </svg>
                </div>
                <div class="service-block__content">
                  <div class="service-block__title section__title section__title_style3">{{$t("internet")}}</div>
                  <div class="service-block__body">
                    <div class="circle-bg svg-icon color-green_yellow" aria-hidden="true">
                      <svg role="img" width="130" height="130" aria-hidden="true">
                        <use xlink:href="#svg-icon-circle"></use>
                      </svg>
                    </div>
                    <div class="circle-bg svg-icon" aria-hidden="true">
                      <svg role="img" width="130" height="130" aria-hidden="true">
                        <use xlink:href="#svg-icon-circle2"></use>
                      </svg>
                    </div>
                    <div class="circle-content">
                      {{$t("upTo", { count: getInternetSpeed(product.ServiceObject) })}}
                    </div>
                  </div>
                  <div class="service-block__footer">
                    <div class="service-block__type">
                      {{ getService(product.ServiceObject, 'Интернет')?.ServiceObject[0]?.technology }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6" v-else>
              <div class="service-block service-block_disabled box">
                <div class="service-block__icon box__icon svg-icon color-white bg-green_light" aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-wifi"></use>
                  </svg>
                </div>
                <div class="service-block__content">
                  <div class="service-block__title section__title section__title_style3">{{$t("internet")}}</div>
                  <div class="service-block__body">
                    <div class="circle-bg svg-icon color-green_yellow" aria-hidden="true">
                      <svg role="img" width="130" height="130" aria-hidden="true">
                        <use xlink:href="#svg-icon-circle"></use>
                      </svg>
                    </div>
                    <div class="circle-bg svg-icon" aria-hidden="true">
                      <svg role="img" width="130" height="130" aria-hidden="true">
                        <use xlink:href="#svg-icon-circle2"></use>
                      </svg>
                    </div>
                    <div class="circle-content">
                      <!-- {{ $t("unknown") }} -->
                    </div>
                  </div>
                  <div class="service-block__footer">
                    <div class="service-block__type">ADSL</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6" v-if="getService(product.ServiceObject, 'ТВ')">
              <div class="service-block box">
                <div class="service-block__icon box__icon svg-icon color-white bg-green_light" aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-desktop"></use>
                  </svg>
                </div>
                <div class="service-block__content">
                  <div class="service-block__title section__title section__title_style3">{{$t("tv")}}</div>
                  <div class="service-block__body">
                    <div class="circle-bg svg-icon color-green_yellow" aria-hidden="true">
                      <svg role="img" width="130" height="130" aria-hidden="true">
                        <use xlink:href="#svg-icon-circle"></use>
                      </svg>
                    </div>
                    <div class="circle-bg svg-icon" aria-hidden="true">
                      <svg role="img" width="130" height="130" aria-hidden="true">
                        <use xlink:href="#svg-icon-circle2"></use>
                      </svg>
                    </div>
                    <div class="circle-content">
                      {{getChannelCount(getService(product.ServiceObject, 'ТВ')?.ServiceObject[0]?.Service)}} {{$t("channels")}}
                    </div>
                  </div>
                  <div class="service-block__footer">
                    <div class="service-block__type">
                      <button class="link" type="button" @click.prevent.stop="show()">{{$t("channelList")}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6" v-else>
              <div class="service-block service-block_disabled box">
                <div class="service-block__icon box__icon svg-icon color-white bg-green_light" aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-desktop"></use>
                  </svg>
                </div>
                <div class="service-block__content">
                  <div class="service-block__title section__title section__title_style3">{{$t("tv")}}</div>
                  <div class="service-block__body">
                    <div class="circle-bg svg-icon color-green_yellow" aria-hidden="true">
                      <svg role="img" width="130" height="130" aria-hidden="true">
                        <use xlink:href="#svg-icon-circle"></use>
                      </svg>
                    </div>
                    <div class="circle-bg svg-icon" aria-hidden="true">
                      <svg role="img" width="130" height="130" aria-hidden="true">
                        <use xlink:href="#svg-icon-circle2"></use>
                      </svg>
                    </div>
                    <div class="circle-content">
                      <!-- 110 {{$t("channels")}} -->
                    </div>
                  </div>
                  <div class="service-block__footer">
                    <div v-if="false" class="service-block__type">
                      <router-link class="link" to="/change-tariff">{{$t("connectService")}}</router-link>
                    </div>
                    <div class="service-block__status"><span class="status-icon svg-icon" aria-hidden="true">
                            <svg role="img" width="24" height="24" aria-hidden="true">
                              <use xlink:href="#svg-icon-close"></use>
                            </svg></span><span class="status-text">{{$t("notConnected")}}</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12" v-if="getService(product.ServiceObject, 'Телефония')">
              <div class="service-block service-block_horizontal box">
                <div class="service-block__icon box__icon svg-icon color-white bg-green_light" aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-mobile"></use>
                  </svg>
                </div>
                <div class="service-block__content">
                  <div class="service-block__title section__title section__title_style3">{{$t("telephony")}}</div>
                  <div class="service-block__footer">
                    <div class="row align-items-center">
                      <div class="col-12 col-md-6" v-if="false">
                        <div class="service-block__date">Действует до 31.03.2020</div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="service-block__status"><span class="status-icon svg-icon" aria-hidden="true">
                                <svg role="img" width="24" height="24" aria-hidden="true">
                                  <use xlink:href="#svg-icon-check"></use>
                                </svg></span><span class="status-text">{{$t("connected")}}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12" v-else>
              <div class="service-block service-block_horizontal service-block_disabled box">
                <div class="service-block__icon box__icon svg-icon color-white bg-green_light" aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-mobile"></use>
                  </svg>
                </div>
                <div class="service-block__content">
                  <div class="service-block__title section__title section__title_style3">{{$t("telephony")}}</div>
                  <div class="service-block__footer">
                    <div class="row align-items-center">
                      <div v-if="false" class="col-12 col-md-6">
                        <div class="service-block__date">
                          <router-link class="link" to="/change-tariff">{{$t("connectService")}}</router-link>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="service-block__status"><span class="status-icon svg-icon" aria-hidden="true">
                                <svg role="img" width="24" height="24" aria-hidden="true">
                                  <use xlink:href="#svg-icon-close"></use>
                                </svg></span><span class="status-text">{{$t("notConnected")}}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="product-block" v-if="!contract.ProductObject || isDisabled">
        <div class="col-12 col-lg-6">
          <div class="row">
            <div class="col-12">
              <div class="about-assistant box bg-white disabled-block">
                <div class="about-assistant__icon box__icon svg-icon color-white bg-green_light is-disabled"
                  aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-wallet"></use>
                  </svg>
                </div>
                <div class="about-assistant__content">
                  <div class="about-assistant__title section__title section__title_style3">{{$t("tariffPlan")}}</div>
                  <div class="tariff__title section__title section__title_style3" style="padding-right: 43px;">
                    {{ $t("unknown") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="info-block box bg-white disabled-block">
                <div class="info-block__icon box__icon svg-icon color-white bg-green_light is-disabled" aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-assistant"></use>
                  </svg>
                </div>
                <div class="info-block__content">
                  <div class="info-block__title section__title section__title_style3">{{$t("assistant")}}</div>
                  <div class="info-block__descr section__description color-gray">
                    <p>{{$t("assistantText")}}</p>
                  </div>
                  <div class="btn-group btn-group_double">
                    <button class="btn btn_default is-disabled" type="button">
                            <span class="btn__text">
                              <span class="btn__icon svg-icon" aria-hidden="true">
                                <svg role="img" width="24" height="24" aria-hidden="true">
                                  <use xlink:href="#svg-icon-phone2"></use>
                                </svg>
                              </span>
                            </span>
                    </button>
                    <button class="btn btn_default is-disabled" type="button">
                            <span class="btn__text">
                              <span class="btn__icon svg-icon" aria-hidden="true">
                                <svg role="img" width="24" height="24" aria-hidden="true">
                                  <use xlink:href="#svg-icon-chat"></use>
                                </svg>
                              </span>
                            </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="info-block box bg-white">
                <div class="info-block__icon box__icon svg-icon color-white bg-green_light" aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-mail"></use>
                  </svg>
                </div>
                <div class="info-block__content">
                  <div class="info-block__title section__title section__title_style3">{{$t("messages")}}</div>
                  <div class="info-block__descr section__description color-gray">
                    <p v-if="newMessage">{{ newMessage.message_object.title }}</p>
                    <p v-else>{{$t("notNewMessage")}}</p>
                  </div>
                  <button :disabled="!newMessage" :class="{'disabled-btn': !newMessage}"
                          @click="$router.push(`/message/${newMessage.id}`)"
                          class="btn btn_white btn_more btn_with-icon" type="button"><span class="btn__text">{{$t("more")}}</span><span
                      class="btn__icon svg-icon" aria-hidden="true">
                          <svg role="img" width="20" height="20" aria-hidden="true">
                            <use xlink:href="#svg-icon-arrow-next"></use>
                          </svg></span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="service-block service-block_disabled box">
                <div class="service-block__icon box__icon svg-icon color-white bg-green_light" aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-wifi"></use>
                  </svg>
                </div>
                <div class="service-block__content">
                  <div class="service-block__title disabled__title section__title section__title_style3">{{$t("internet")}}</div>
                  <div class="service-block__body">
                    <div class="circle-bg svg-icon color-green_yellow" aria-hidden="true">
                      <svg role="img" width="130" height="130" aria-hidden="true">
                        <use xlink:href="#svg-icon-circle"></use>
                      </svg>
                    </div>
                    <div class="circle-bg svg-icon" aria-hidden="true">
                      <svg role="img" width="130" height="130" aria-hidden="true">
                        <use xlink:href="#svg-icon-circle2"></use>
                      </svg>
                    </div>
                    <div class="circle-content">
                      <!-- {{ $t("unknown") }} -->
                    </div>
                  </div>
                  <div class="service-block__footer">
                    <span class="status-icon svg-icon" aria-hidden="true">
                    <svg role="img" width="24" height="24" aria-hidden="true">
                                  <use xlink:href="#svg-icon-close"></use>
                                </svg></span><span class="status-text">{{$t("notConnected")}}</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="col-12 col-sm-6" >
              <div class="service-block service-block_disabled box">
                <div class="service-block__icon box__icon svg-icon color-white bg-green_light" aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-desktop"></use>
                  </svg>
                </div>
                <div class="service-block__content">
                  <div class="service-block__title disabled__title section__title section__title_style3">{{$t("tv")}}</div>
                  <div class="service-block__body">
                    <div class="circle-bg svg-icon color-green_yellow" aria-hidden="true">
                      <svg role="img" width="130" height="130" aria-hidden="true">
                        <use xlink:href="#svg-icon-circle"></use>
                      </svg>
                    </div>
                    <div class="circle-bg svg-icon" aria-hidden="true">
                      <svg role="img" width="130" height="130" aria-hidden="true">
                        <use xlink:href="#svg-icon-circle2"></use>
                      </svg>
                    </div>
                    <div class="circle-content">
                      <!-- 110 {{$t("channels")}} -->
                    </div>
                  </div>
                  <div class="service-block__footer">
                    <div v-if="false" class="service-block__type">
                      <router-link class="link" to="/change-tariff">{{$t("connectService")}}</router-link>
                    </div>
                    <div class="service-block__status"><span class="status-icon svg-icon" aria-hidden="true">
                            <svg role="img" width="24" height="24" aria-hidden="true">
                              <use xlink:href="#svg-icon-close"></use>
                            </svg></span><span class="status-text">{{$t("notConnected")}}</span></div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="col-12">
              <div class="service-block service-block_horizontal service-block_disabled box">
                <div class="service-block__icon box__icon svg-icon color-white bg-green_light" aria-hidden="true">
                  <svg role="img" width="30" height="30" aria-hidden="true">
                    <use xlink:href="#svg-icon-mobile"></use>
                  </svg>
                </div>
                <div class="service-block__content">
                  <div class="service-block__title disabled__title section__title section__title_style3">{{$t("telephony")}}</div>
                  <div class="service-block__footer">
                    <div class="row align-items-center">
                      <div v-if="false" class="col-12 col-md-6">
                        <div class="service-block__date">
                          <router-link class="link" to="/change-tariff">{{$t("connectService")}}</router-link>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="service-block__status"><span class="status-icon svg-icon" aria-hidden="true">
                                <svg role="img" width="24" height="24" aria-hidden="true">
                                  <use xlink:href="#svg-icon-close"></use>
                                </svg></span><span class="status-text">{{$t("notConnected")}}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Список каналов-->
  <div class="modal modal-channels fade modal_show" tabindex="-1" v-if="showModal" role="dialog" aria-hidden="true" id="modal-channels" aria-label="{{$t('channelList')}}">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title section__title section__title_style3">
            {{$t("channelList")}}
          </div>
          <button class="btn svg-icon modal-close" type="button" @click="closeModal" data-dismiss="modal" aria-label="Закрыть">
            <svg role="img" width="14" height="14" aria-hidden="true">
              <use xlink:href="#svg-icon-close"></use>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table table_default">
              <thead class="thead">
                <tr class="tr">
                  <th class="th">№</th>
                  <th class="th">Канал</th>
                  <th class="th">Категория</th>
                </tr>
              </thead>
                <tbody class="tbody" v-if="tariffType === 'base' || tariffType === 'middle' || tariffType === 'extended'">
                  <tr class="tr">
                    <td class="td">1</td>
                    <td class="td">QAZAQSTAN</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">2</td>
                    <td class="td">Хабар</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">3</td>
                    <td class="td">Хабар 24</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">4</td>
                    <td class="td">Балапан</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">5</td>
                    <td class="td">Ел Арна</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">6</td>
                    <td class="td">QAZSPORT</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">7</td>
                    <td class="td">Kazakh TV</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">8</td>
                    <td class="td">КТК</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">9</td>
                    <td class="td">НТК</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">10</td>
                    <td class="td">Астана</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">11</td>
                    <td class="td">Алматы</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">12</td>
                    <td class="td">Abai TV</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">13</td>
                    <td class="td">Той Думан</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">14</td>
                    <td class="td">Gakku Media</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">15</td>
                    <td class="td">MuzLife</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">16</td>
                    <td class="td">Первый канал Евразия</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">17</td>
                    <td class="td">7 канал</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">18</td>
                    <td class="td">31 канал</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">19</td>
                    <td class="td">Туркестан</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">20</td>
                    <td class="td">TALIM TV</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">21</td>
                    <td class="td">Caspian NEWS</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">22</td>
                    <td class="td">Atameken Business</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">23</td>
                    <td class="td">MUNARA TV</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">24</td>
                    <td class="td">Жетісу</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">25</td>
                    <td class="td">Новое телевидение</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">26</td>
                    <td class="td">Jibek Joly</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">27</td>
                    <td class="td">Мужское кино</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">28</td>
                    <td class="td">Киносерия</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">29</td>
                    <td class="td">Индийское кино</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">30</td>
                    <td class="td">Кинокомедия</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">31</td>
                    <td class="td">Наше новое кино</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">32</td>
                    <td class="td">Родное кино</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">33</td>
                    <td class="td">Киномикс</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">34</td>
                    <td class="td">Дом Кино</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">35</td>
                    <td class="td">Дом Кино Премиум</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">36</td>
                    <td class="td">Победа</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">37</td>
                    <td class="td">Cinema</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">38</td>
                    <td class="td">Индия</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">39</td>
                    <td class="td">Q KinoAlem</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">40</td>
                    <td class="td">Q Kinohit</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">41</td>
                    <td class="td">Bollywood</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">42</td>
                    <td class="td">Eurosport 1</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">43</td>
                    <td class="td">Eurosport 2</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">44</td>
                    <td class="td">inSport</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">45</td>
                    <td class="td">MMA-TV.COM</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">46</td>
                    <td class="td">Qsport</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">47</td>
                    <td class="td">Qsport Extra</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">48</td>
                    <td class="td">inTennis</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">49</td>
                    <td class="td">Карусель Int</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">50</td>
                    <td class="td">О!</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">51</td>
                    <td class="td">Nickelodeon</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">52</td>
                    <td class="td">[KAZ] Nickelodeon</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">53</td>
                    <td class="td">Nick jr</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">54</td>
                    <td class="td">Первый канал Всемирная сеть</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">55</td>
                    <td class="td">СТС I International</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">56</td>
                    <td class="td">Рен ТВ</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">57</td>
                    <td class="td">НТВ Мир</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">58</td>
                    <td class="td">Бобер</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">59</td>
                    <td class="td">Время: Далекое и Близкое</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">60</td>
                    <td class="td">Музыка Первого</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">61</td>
                    <td class="td">Телекафе</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">62</td>
                    <td class="td">КВН ТВ</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">63</td>
                    <td class="td">Домашний International</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">64</td>
                    <td class="td">ТНТ 4 Int</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">65</td>
                    <td class="td">ТНТ Музыка</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">66</td>
                    <td class="td">Ля Минор</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">67</td>
                    <td class="td">Кухня ТВ</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">68</td>
                    <td class="td">365 дней ТВ</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">69</td>
                    <td class="td">Авто Плюс</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">70</td>
                    <td class="td">Перец Int</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">71</td>
                    <td class="td">Жара</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">72</td>
                    <td class="td">Т24</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">73</td>
                    <td class="td">ICONCERTS</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">74</td>
                    <td class="td">Живая природа</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">75</td>
                    <td class="td">Глазами туриста</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">76</td>
                    <td class="td">Кто есть кто</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">77</td>
                    <td class="td">English club TV</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">78</td>
                    <td class="td">Поехали</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">79</td>
                    <td class="td">HDL</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">80</td>
                    <td class="td">CNN</td>
                    <td class="td">Новости</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">81</td>
                    <td class="td">Euronews</td>
                    <td class="td">Новости</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">82</td>
                    <td class="td">РБК ТВ</td>
                    <td class="td">Новости</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">83</td>
                    <td class="td">[ENG] Nick Jr.</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">84</td>
                    <td class="td">[ENG] Eurosport</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">85</td>
                    <td class="td">[ENG] Eurosport 2</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">86</td>
                    <td class="td">[ENG] .Black</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">87</td>
                    <td class="td">[ENG] .Sci-Fi</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">88</td>
                    <td class="td">[ENG] .Red</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                </tbody>
                <tbody class="tbody" v-if="tariffType === 'middle' || tariffType === 'extended'">
                  <tr class="tr">
                    <td class="td">89</td>
                    <td class="td">A1</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">90</td>
                    <td class="td">Кинохит</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">91</td>
                    <td class="td">Киносвидание</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">92</td>
                    <td class="td">Киносемья</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">93</td>
                    <td class="td">Кинопремьера</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">94</td>
                    <td class="td">Киноужас</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">95</td>
                    <td class="td">НСТ</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">96</td>
                    <td class="td">Матч! Планета</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">97</td>
                    <td class="td">Tiji</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">98</td>
                    <td class="td">Мульт</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">99</td>
                    <td class="td">Cartoon network</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">100</td>
                    <td class="td">СТС Kids</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">101</td>
                    <td class="td">Kids TV</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">102</td>
                    <td class="td">Пятница Int</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">103</td>
                    <td class="td">Clubbing TV</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">104</td>
                    <td class="td">Мир 24</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">105</td>
                    <td class="td">viju History</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">106</td>
                    <td class="td">viju Nature</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">107</td>
                    <td class="td">viju Explore</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">108</td>
                    <td class="td">Travel & Adventure</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">109</td>
                    <td class="td">Моя Планета</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">110</td>
                    <td class="td">History 2</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">111</td>
                    <td class="td">Тұран ТВ</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">112</td>
                    <td class="td">Travel XP</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">113</td>
                    <td class="td">[ENG] Viasat History</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">114</td>
                    <td class="td">[ENG] Travel+Adventure</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">115</td>
                    <td class="td">[ENG] Cartoon Network</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                </tbody>
                <tbody class="tbody" v-if="tariffType === 'extended'">
                  <tr class="tr">
                    <td class="td">116</td>
                    <td class="td">Amedia Premium</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">117</td>
                    <td class="td">Amedia HIT</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">118</td>
                    <td class="td">viju TV 1000</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">119</td>
                    <td class="td">viju TV 1000 Action</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">120</td>
                    <td class="td">ТВ 1000 Русское кино</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">121</td>
                    <td class="td">Дорама</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">122</td>
                    <td class="td">START World</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">123</td>
                    <td class="td">RED</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">124</td>
                    <td class="td">BLACK</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">125</td>
                    <td class="td">Sci-Fi</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">126</td>
                    <td class="td">UDAR</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">127</td>
                    <td class="td">viju Sport</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">128</td>
                    <td class="td">Бокс ТВ</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">129</td>
                    <td class="td">КХЛ</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">130</td>
                    <td class="td">ТНТ Int</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">131</td>
                    <td class="td">ТВЦ</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">132</td>
                    <td class="td">Россия РТР</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">133</td>
                    <td class="td">Россия К</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">134</td>
                    <td class="td">TERRA</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">135</td>
                    <td class="td">Curiosity Stream</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">136</td>
                    <td class="td">Охотник и рыболов</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">137</td>
                    <td class="td">Animal Planet</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">138</td>
                    <td class="td">TRT Avaz</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">139</td>
                    <td class="td">Живи активно</td>
                    <td class="td">Познавательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">140</td>
                    <td class="td">RTVi</td>
                    <td class="td">Новости</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">141</td>
                    <td class="td">TRT World</td>
                    <td class="td">Новости</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">142</td>
                    <td class="td">Россия 24</td>
                    <td class="td">Новости</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">143</td>
                    <td class="td">[ENG] Museum</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">144</td>
                    <td class="td">[ENG] TV 1000</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">145</td>
                    <td class="td">[ENG] TV 1000 Action</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">146</td>
                    <td class="td">[KOR] Дорама</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">147</td>
                    <td class="td">[ENG] viju Sport</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">148</td>
                    <td class="td">[ENG] Nickelodeon</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">149</td>
                    <td class="td">[ENG] Amedia Hit HD</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">150</td>
                    <td class="td">[ENG] RED</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">151</td>
                    <td class="td">[ENG] BLACK</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">152</td>
                    <td class="td">[ENG] Sci-Fi</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                </tbody>
                <tbody class="tbody" v-if="tariffType === 'social' || tariffType === 'cinema' || tariffType === 'kids' || tariffType === 'sport'">
                  <tr class="tr">
                    <td class="td">1</td>
                    <td class="td">Qazaqstan</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">2</td>
                    <td class="td">Хабар</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">3</td>
                    <td class="td">Kazakh TV</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">4</td>
                    <td class="td">Первый канал Евразия</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">5</td>
                    <td class="td">7 канал</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">6</td>
                    <td class="td">31 канал</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">7</td>
                    <td class="td">СТВ</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">8</td>
                    <td class="td">Astana TV</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">9</td>
                    <td class="td">Хабар 24</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">10</td>
                    <td class="td">Ел арна</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">11</td>
                    <td class="td">Q Kino Hit</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">12</td>
                    <td class="td">Q Kino Alem</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">13</td>
                    <td class="td">Balapan</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">14</td>
                    <td class="td">Qazsport</td>
                    <td class="td">Казахстанские каналы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">15</td>
                    <td class="td">Первый канал. Всемирная сеть</td>
                    <td class="td">Российские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">16</td>
                    <td class="td">Пятый канал</td>
                    <td class="td">Российские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">17</td>
                    <td class="td">TRT AVAZ</td>
                    <td class="td">Этнические</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">18</td>
                    <td class="td">Nickelodeon (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">19</td>
                    <td class="td">Nick Jr. (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">20</td>
                    <td class="td">Eurosport 1 (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">21</td>
                    <td class="td">Eurosport 2 (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">22</td>
                    <td class="td">TLC (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">23</td>
                    <td class="td">Viasat History (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">24</td>
                    <td class="td">Viasat Explore (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">25</td>
                    <td class="td">Viasat Nature (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">26</td>
                    <td class="td">Travel and Adventure (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">27</td>
                    <td class="td">Amedia 1 (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">28</td>
                    <td class="td">Cartoon Network (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">29</td>
                    <td class="td">Discovery Channel (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">30</td>
                    <td class="td">TV1000 (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">31</td>
                    <td class="td">TV1000 Action (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">32</td>
                    <td class="td">Amedia Hit (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">33</td>
                    <td class="td">Amedia Premium (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">34</td>
                    <td class="td">Дорама (kor/tur)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">35</td>
                    <td class="td">Viasat Sport (eng)</td>
                    <td class="td">Иностранный язык</td>
                  </tr>
                </tbody>
                <tbody class="tbody" v-if="tariffType === 'cinema'">
                  <tr class="tr">
                    <td class="td">36</td>
                    <td class="td">TV1000</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">37</td>
                    <td class="td">TV1000 Action</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">38</td>
                    <td class="td">ТВ 1000. Русское кино</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">39</td>
                    <td class="td">Дом кино</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">40</td>
                    <td class="td">Дом Кино ПРЕМИУМ</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">41</td>
                    <td class="td">Победа</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">42</td>
                    <td class="td">Мужское кино</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">43</td>
                    <td class="td">ИНДИЙСКОЕ КИНО</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">44</td>
                    <td class="td">КИНОКОМЕДИЯ</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">45</td>
                    <td class="td">Наше новое кино</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">46</td>
                    <td class="td">РОДНОЕ КИНО</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">47</td>
                    <td class="td">КИНОМИКС</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">48</td>
                    <td class="td">Киноужас</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">49</td>
                    <td class="td">КИНОПРЕМЬЕРА</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">50</td>
                    <td class="td">Кинохит</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">51</td>
                    <td class="td">КИНОСВИДАНИЕ</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">52</td>
                    <td class="td">КИНОСЕМЬЯ</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">53</td>
                    <td class="td">НСТВ</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">54</td>
                    <td class="td">КИНОСЕРИЯ</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">55</td>
                    <td class="td">Zee Russia</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">56</td>
                    <td class="td">Синема</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">57</td>
                    <td class="td">Bollywood</td>
                    <td class="td">Фильмы и сериалы</td>
                  </tr>
                </tbody>
                <tbody class="tbody" v-if="tariffType === 'kids'">
                  <tr class="tr">
                    <td class="td">36</td>
                    <td class="td">Карусель</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">37</td>
                    <td class="td">О! </td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">38</td>
                    <td class="td">Мульт </td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">39</td>
                    <td class="td">Cartoon Network</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">40</td>
                    <td class="td">Nickelodeon</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">41</td>
                    <td class="td">Nick Jr.</td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">42</td>
                    <td class="td">СТС kids </td>
                    <td class="td">Детские</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">43</td>
                    <td class="td">TiJi</td>
                    <td class="td">Детские</td>
                  </tr>
                </tbody>
                <tbody class="tbody" v-if="tariffType === 'sport'">
                  <tr class="tr">
                    <td class="td">36</td>
                    <td class="td">inSport</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">37</td>
                    <td class="td">UDAR</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">38</td>
                    <td class="td">Q Sport Extra</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">39</td>
                    <td class="td">БОКС ТВ ПЛЮС</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">40</td>
                    <td class="td">Viasat Sport</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">41</td>
                    <td class="td">M-1 Global</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">42</td>
                    <td class="td">Q Sport</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">43</td>
                    <td class="td">Eurosport 1</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">44</td>
                    <td class="td">Eurosport 2</td>
                    <td class="td">Спортивные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">45</td>
                    <td class="td">Матч! Планета</td>
                    <td class="td">Спортивные</td>
                  </tr>
                </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>
<script>
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
export default {
    props: {
      contract: {
        type: Object,
        default: function () {
            return {
            idContract: '',
            numberContract: '',
            obk: '',
            payment: '',
            PaymentObject: [
                {
                    extId: '',
                    source: '',
                    payDt: '',
                    pamount: ''
                }
            ]
            }
        }
      },
      isDisabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        showModal: false,
        tariffType: ''
      }
    },
    computed: {
      ...mapGetters({
        newMessage: 'messages/newMessage'
      }),
    },
    methods: {
      ...mapActions({
        getCategory: 'assistant/getCategory',
      }),
      ...mapMutations({
        setAssistantType: 'assistant/setAssistantType'
      }),
      getService(serviceObject, serviceType) {
        if (!serviceObject?.length) {
          return false
        }
        return serviceObject.find(service => service.serviceType === serviceType)
      },
      getInternetSpeed(service){
        let internetBlock = this.getService(service, 'Интернет')
        if(!internetBlock?.ServiceObject){
          return 0;
        }
        let activeBlock = internetBlock.ServiceObject.find(item => item.status === "A")
        return activeBlock?.traffic_world ? parseInt(activeBlock.traffic_world.substring(13)) : 0;
      },
      openAssistant(assistantType) {
        const bodyElem = document.querySelector('body')
        if (!window.matchMedia("(min-width: 1px) and (max-width: 1199px)").matches) {
          bodyElem.classList.contains('assistant-hide') && bodyElem.classList.remove("assistant-hide")
        } else {
          bodyElem.classList.contains('assistant-hide') && bodyElem.classList.remove("assistant-hide")
          bodyElem.classList.contains('assistant-open') || bodyElem.classList.add("assistant-open")
        }
        if (assistantType === 'assistant-chat') {
          this.getCategory()
        }
        this.setAssistantType(assistantType)
      },
      formatOBK(obk){
        return (+obk.toFixed(2)).toLocaleString('ru');
      },
      getChannelCount(tariffName){
        switch (tariffName) {
          case 'Абон. плата за пакет базовый':
            this.tariffType = "base"; 
            return 88;
          case 'Абон. плата за пакет средний':
            this.tariffType = "middle";
            return 115;
          case 'Абон. плата за пакет расширенный':
            this.tariffType = "extended"; 
            return 152;
          case 'Абон. плата за пакет социальный':
            this.tariffType = "social"; 
            return 35;
          case 'Абон. плата за пакет соц + кино':
            this.tariffType = "cinema"; 
            return 57;
          case 'Абон. плата за пакет соц + детский':
            this.tariffType = "kids"; 
            return 43;
          case 'Абон. плата за пакет соц + спорт':
            this.tariffType = "sport"; 
            return 45;
          default:
            this.tariffType = 0;
        }
      },
      show() {
        this.showModal = true
      },
      closeModal() {
        this.showModal = false
      },
    }
}
</script>
<style>
.product-block{
  display: flex;
  flex-wrap: wrap;
}
.block_name{
  display: inline-block;
  width: 190px;
}
.secondary_block{
  font-size: 18px;
  margin-top: 5px;
  color: #636363;
}
.disabled__title{
  color: #8f8f8f !important;
}
.disabled-block{
  color: gray;
}
.is-disabled{
  background-color: #d4d4d4;
}
.is-disabled::before{
  background-color: #d4d4d4;
}
.disabled-btn{
  color: gray;
  border-color: gray;
}
.disabled-btn:hover, .disabled-btn:active, .disabled-btn:visited{
  color: gray;
  border-color: gray;
  background-color: #fff;
}
.tariff-name{
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.tariff-name img{
  width: 20px;
  cursor: pointer;
}
.modal_show{
  display: block;
  opacity: 1;
  background: rgba(255,255,255,.5);
}
.modal-content{
  padding: 35px;
}
.modal-body{
  max-height: 80vh;
  overflow: auto;
  border-radius: 0;
}
.modal-dialog-centered{
  margin-top: 60px;
}
.modal-body .table .td{
  padding: 0;
}
@media (max-width: 768px) {
  .btn_finance{
    margin-top: 15px;
  }
  .block_name{
    width: 150px;
  }
  .mt_10{
    margin-top: 10px;
  }
  .mt_25{
    margin-top: 25px;
  }
  .secondary_block{
    font-size: 16px;
    margin-top: 4px;
  }
}
</style>